export default {
    'efaktura-list': '/velg-efaktura',
    'choose-person': '/velg-person',
    summary: '/oppsummering',
    update: '/oppdater-deling',
    cancel: '#/',
    home: '/',
};
